import { AlertTriangle } from 'lucide-react';
import type { InvoiceIssuerField } from '@/shared/api';
import { missingIssuerText } from './invoiceIssuerPresentation';

/**
 * Fehlen einer Vorlage Pflichtangaben zum Aussteller, stellt die Automatik mit ihr keine Rechnung
 * aus — die Arbeit wartet und läuft nach dem Ergänzen von selbst weiter.
 */
export function InvoiceIssuerHint({ missing }: { missing: readonly InvoiceIssuerField[] }) {
  if (missing.length === 0) return null;
  return (
    <p className="border-amber/40 bg-amber-soft text-ink mt-3 flex gap-2 rounded-md border p-3 text-sm">
      <AlertTriangle className="text-gold mt-0.5 size-4 shrink-0" aria-hidden />
      <span>
        <b className="font-semibold">Rechnungsdaten unvollständig</b> – automatische Rechnungen mit
        dieser Vorlage warten, bis die Angaben ergänzt sind. {missingIssuerText(missing)}
      </span>
    </p>
  );
}
